var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropboxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 24,
  viewBox: "0 0 28 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.9997 0L0 4.5L6.9997 9L14.0006 4.5L6.9997 0Z",
  fill: "#0061FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.0004 0L14.0007 4.5L21.0004 9L28.0001 4.5L21.0004 0Z",
  fill: "#0061FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 13.5L6.9997 18L14.0006 13.5L6.9997 9L0 13.5Z",
  fill: "#0061FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.0004 9L14.0007 13.5L21.0004 18L28.0001 13.5L21.0004 9Z",
  fill: "#0061FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.99976 19.5L14.0006 24L21.0003 19.5L14.0006 15L6.99976 19.5Z",
  fill: "#0061FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 24,
  fill: "white"
})))));
export default SvgDropboxIcon;